import React from 'react';
import { connect } from 'react-redux';
import Error from '../Error';

class ErrorSecurity extends React.Component {

	render() {
		return (
			<Error title={this.props.title} message={this.props.message} />
		)
	}
}

function mapStateToProps(state){
	return {
		title: state.errorSecurity.title,
		message: state.errorSecurity.message
	}
}

export default connect(mapStateToProps)(ErrorSecurity);




// WEBPACK FOOTER //
// ./app/components/security/ErrorSecurity.js